export enum AnalyticsSandboxStatus {
    InProgress = 'in-progress',
    Completed = 'completed',
    Error = 'error',
    Purged = 'purged'
}